import axios from 'axios'
const PAGINATION = 25

const fcts = {
  get(id) {
    return axios
      .get(process.env.API + '/contestround/' + id + '/')
      .then(res => res.data)
  },

  create(round) {
    return axios
      .post(process.env.API + '/contestround/', round)
      .then(res => res.data)
  },

  update(round) {
    return axios
      .put(process.env.API + '/contestround/' + round.id + '/', round)
      .then(res => res.data)
  },

  delete(round) {
    return axios
      .delete(process.env.API + '/contestround/' + round.id + '/')
      .then(res => round)
  },

  getAll () {
    return new Promise((resolve, reject) => {
      let items = []

      var _load = (page) => {
        this.getByPage(page).then((contests) => {
          items.push(...contests)

          if (contests.length === PAGINATION) {
            page++
            _load(page)
          } else {
            resolve(items)
          }
        }).catch(e => {
          reject(e)
        })
      }

      _load(0)
    })
  },

  getByPage (page) {
    return axios
      .get(process.env.API + '/contestround/' + page + '/' + PAGINATION + '/')
      .then(res => res.data)
  },

  getAllByContest (idContest) {
    return new Promise((resolve, reject) => {
        let items = []
  
        var _load = (idContest, page) => {
          this.getByPageByContest(idContest, page).then((rounds) => {
            items.push(...rounds)
  
            if (rounds.length === PAGINATION) {
              page++
              _load(idContest, page)
            } else {
              resolve(items)
            }
          }).catch(e => {
            reject(e)
          })
        }
  
        _load(idContest, 0)
      })
  },

  getByPageByContest (idContest, page) {
    return axios
      .get(process.env.API + '/contest/' + idContest + '/contestround/' + page + '/' + PAGINATION + '/')
      .then(res => res.data)
  },

}

export default fcts



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rocketfid/api/services/round.js
// module id = null
// module chunks = 